import security from '../../common/services/SecurityService';
import { endpoints } from '../../../config';
import { DataCrafterChildSession } from '../types';

export default class DataCrafterService {
    async fetchOutputDocument(sessionId: string, packageId: string): Promise<Blob> {
        try {
            const url = `${endpoints.iotaUrl}data-crafter/package/${sessionId}/${packageId}`;
            const blobResponse = await security.invoke(async token => {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                return await response.blob();
            });

            return blobResponse;
        } catch (error) {
            console.error('Error fetching output document:', error);
            throw error;
        }
    }

    async sendOutput(sessionId: string, packageId: string): Promise<Blob> {
        try {
            const url = `${endpoints.iotaUrl}data-crafter/send-output/${sessionId}/${packageId}`;
            const blobResponse = await security.invoke(async token => {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                return await response.blob();
            });

            return blobResponse;
        } catch (error) {
            console.error('Error sending output document:', error);
            throw error;
        }
    }

    async analyzeDocument(
        sessionId: string,
        packageId: string,
        projectId: string,
        applicationId: string
    ): Promise<void> {
        try {
            const url = `${endpoints.iotaUrl}data-crafter/iota-apps/${sessionId}/${packageId}/analyze/${projectId}/${applicationId}`;
            const analyzeResponse = await security.invoke(async token => {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
            });

            return analyzeResponse;
        } catch (error) {
            console.error('Error sending output document:', error);
            throw error;
        }
    }

    async getChildSessions(sessionId: string): Promise<DataCrafterChildSession[]> {
        try {
            const url = `${endpoints.iotaUrl}data-crafter/${sessionId}/child-sessions`;
            const childSessionsResponse = await security.invoke(async token => {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                return await response.json();
            });

            return childSessionsResponse;
        } catch (error) {
            console.error('Error getting child sessions:', error);
            throw error;
        }
    }
}
